// extracted by mini-css-extract-plugin
export default {"root":"input-label_root__z3FNK"};